<template>
	<v-chip
		x-small
		color="success"
		class="ml-2 new-badge"
	>
		NEW
	</v-chip>
</template>

<script>
export default {
	name: 'NewBadge',
};
</script>

<style scoped>
.new-badge {
	font-weight: 600;
	font-size: 10px;
	letter-spacing: 0.5px;
	animation: pulse 2s infinite;
}

@keyframes pulse {
	0% {
		opacity: 1;
	}
	50% {
		opacity: 0.5;
	}
	100% {
		opacity: 1;
	}
}
</style>
